import CollectivePurchasingService from '../collective-purchasing-service';
import SummaryInfo from './summary-info/summary-info.vue';
import ProcurementGuidelines from './procurement-guidelines/procurement-guidelines.vue';
import PurchaseConfirmAnnouncement from '@/components/purchase-confirm-announcement/purchase-confirm-announcement.vue';
import { isPurchaseTypeFlag } from '@/utils/common.js';
import { successMessage, errorMessage } from '@/utils/message.js';
import QRCode from 'qrcodejs2';
import { mapGetters } from 'vuex';

export default {
  components: {
    SummaryInfo,
    ProcurementGuidelines,
    PurchaseConfirmAnnouncement
  },
  data () {
    return {
      detail: {},
      userInfo: {},
      timer: null,
      id: '',
      dialogFormVisible: false,
      isDisabled: true,
      arr: ['采购公告信息'],// '附件下载'先隐藏
      activeKey: '采购公告信息',
      fileObj: {
        applyBookUrl: '',
        docUrl: '',
        powerAttorneyUrl: '',
        pdfUrl: 'http://fastdfs.jlncjy.com:8098/group1/M00/00/A0/CjwyFGFj90KAba5NAAIWntU2Tck683.pdf'
      },
      status: '',
      statusPay: false, // 支付页面
      payStatus: 'success',
      detailPay: {}, // 支付采购文件费信息
      paySuccessInfo: {}, // 支付成功的信息
      paymentInfo: {},
      payResult: false // 支付结果
    };
  },
  created () {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.id = this.$route.query.id;
    this.status = this.$route.query.status;
    if (this.id) {
      this.getPurchaseProjectDetail('PURCHASE');
      this.getPurchaseProjectDetail('USER'); // 获取用户和项目联系人信息
    }
    // this.isSignin && this.getDownloadAttachmentUrl();
  },
  beforeDestroy () {
    clearInterval(this.timer);
  },
  computed: {
    ...mapGetters([
      'isSignin'
    ])
  },
  methods: {
    toExtendDetail () {
      this.$router.push('/notice-modular/trading-rules-detail?id=' + this.detail.newsId);
    },
    isPurchaseTypeFlag,
    getPurchaseProjectDetail (echoCode) {
      CollectivePurchasingService.getPurchaseProjectDetail({
        purchaseId: this.id,
        echoCode: echoCode
      }).then(res => {
        if (res && res.code === '0') {
          if (echoCode === 'PURCHASE') {
            this.detail = res.data;
            if (this.detail.purchaseType === 1) {
              this.getProjectContractUrl(7);
            } else if (this.detail.purchaseType === 3) {
              this.getProjectContractUrl(6);
            }
          } else {
            this.userInfo = res.data;
          }
          // 获取附件列表
          this.isSignin && this.getDownloadAttachmentUrl();
        }
      });
    },
    getProjectContractUrl (contractType) {
      CollectivePurchasingService.getProjectContractUrl({
        projectId: this.id,
        projectType: 2,
        contractType: contractType
      }).then(res => {
        if (res && res.code === '0') {
          this.fileObj.docUrl = res.data && res.data.url;
        }
      });
    },
    getDownloadAttachmentUrl () {
      this.detail.projectType && CollectivePurchasingService.getDownloadAttachmentUrl(this.detail.projectType).then(res => {
        if (res && res.code === '0') {
          this.fileObj.applyBookUrl = res && res.data && res.data.applyBookUrl;
          this.fileObj.powerAttorneyUrl = res && res.data && res.data.powerAttorneyUrl;
        }
      });
    },
    onSignUp () {
      // this.$router.push('/collective-purchasing/sign-up?id=' + this.id +'&purchaseType=' + this.detail.purchaseType + '&promiseEnterprise=' + this.detail.promiseEnterprise + '&criminalRecord=' + this.detail.criminalRecord + '&qualificationReview=' + this.detail.qualificationReview);
      // // 一般招标和依法必招直接报名
      if (this.isPurchaseTypeFlag(this.detail.purchaseType)) {
        this.isDisabled = false;
        this.onAgree();
      } else {
        this.dialogFormVisible = true;
      }
    },
    // 点击同意，立即报名
    onAgree () {
      if (this.isDisabled) { return; }
      console.log(this.detail, this.detail.qualificationReview);
      // 当qualificationReview=2时,资格后审 调接口去检查是否交纳采购文件费
      if (this.detail.qualificationReview === 2) {
        CollectivePurchasingService.checkPayFileFeeByUser(this.id).then(res => {
          if (res && res.code === '0') {
            if (res.data === true) {
              this.dialogFormVisible = false;
              this.$router.push('/collective-purchasing/sign-up?id=' + this.id + '&purchaseType=' + this.detail.purchaseType + '&promiseEnterprise=' + this.detail.promiseEnterprise + '&criminalRecord=' + this.detail.criminalRecord + '&qualificationReview=' + this.detail.qualificationReview);
            } else {
              this.statusPay = true;
              this.getPaymentInfo();
            }
          }
        });
      } else {
        this.dialogFormVisible = false;
        this.$router.push('/collective-purchasing/sign-up?id=' + this.id + '&purchaseType=' + this.detail.purchaseType + '&promiseEnterprise=' + this.detail.promiseEnterprise + '&criminalRecord=' + this.detail.criminalRecord + '&qualificationReview=' + this.detail.qualificationReview);
      }
    },
    // 根据url转换二维码
    qrcode (url) {
      document.getElementById('qrcode').innerHTML = '';
      new QRCode('qrcode', {
        width: 300,
        height: 300,
        text: url
      });
    },
    // 获取支付公告费信息 二维码
    getPaymentInfo () {
      const params = {
        productName: '采购文件费',
        id: this.id,
        transactionType: 4,
        type: 2
      };
      CollectivePurchasingService.getPaymentInfo(params).then(res => {
        if (res.code === '0') {
          this.paymentInfo = res.data;
          this.$nextTick(() => {
            this.qrcode(res.data.codeUrl);
          });
          this.timer = setInterval(() => {
            this.getPaymentResult(res.data.transactionNo);
          }, 3000);
        } else if (res && res.reason) {
          errorMessage(res && res.reason);
        } else {
          errorMessage('获取信息失败');
        }
      }, (error) => {
        if (error && error.data && error.data.reason) {
          errorMessage(error.data.reason);
        } else {
          errorMessage('获取信息失败');
        }
      });
    },
    // 获取VX交易结果
    getPaymentResult (transactionNo) {
      CollectivePurchasingService.getPaymentResult(transactionNo, 4).then(res => {
        if (res.code === '0') {
          if (!res.data) {
            return;
          }
          if (res.data.status === 1) {
            this.payStatus = 'onGoing';
          } else if (res.data.status === 2 || res.data.status === 3) {
            this.payStatus = res.data.status === 3 ? 'success' : 'failed';
            if (res.data.status === 3) {
              this.statusPay = false;
              this.payResult = true;
              this.paySuccessInfo = res.data;
              successMessage('支付成功');
            } else {
              errorMessage('支付失败');
            }
            clearInterval(this.timer);
          }
        } else {
          let message = res && res.reason ? res.reason : '获取支付结果失败';
          clearInterval(this.timer);
          errorMessage(message);
        }
      }, (error) => {
        let message = error && error.data && error.data.reason ? error.data.reason : '获取支付结果失败';
        clearInterval(this.timer);
        errorMessage(message);
      });
    },
    // 查看采购文件跳转
    goToFilepage () {
      this.$router.push('/person-center/purchase-business/purchase-file-download/list');
    },
    changeActiveIndex (key) {
      this.activeKey = key;
    },
    enabledBtn () {
      this.isDisabled = false;
    },
    openWindow (key) {
      // 判断是否登录
      if (!this.isSignin) {
        this.$router.push('/signin');
        return;
      }
      if (key === 'docUrl' || key === 'pdfUrl') {
        window.open(this.fileObj[key]);
      } else {
        let link = document.createElement('a');
        link.style.display = 'none';
        link.href = 'data:file/doc;base64,' + this.fileObj[key];
        link.download = (key === 'applyBookUrl' ? '意向供应人（投标人）申请书.doc' : '授权委托书.doc');
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(link.href);
      }
    },
    // 下载模版
    downTemplate () {
      // window.open('/交易保证金的注意事项.pdf');
    }
  }
};
